export const hideJobErrorMessage = "Cannot hide job";
export const deleteJobErrorMessage = "Cannot delete job";
export const deleteJobSuccessTitle = "Job deleted";
export const deleteJobSuccessMessage = "Successfully deleted job";
export const deleteJobConfirmTitle = "Delete Job?";
export const deleteJobConfirmMessage = "Are you sure?";
